export default "__VITE_ASSET__DeY1tnuQ__"